@if (active()) {
<div class="pane">
  <ng-content></ng-content>
</div>
}
